module.exports = "/subscriptions/assets/7d13d9e1563dbb2369014389f0533a54.svg";